const DOWNLOADED_FILE_ID = 'useDownloadFile_file';

export function downloadFile(fileTextOrBlob: Blob | string, fileName: string, extension: string = 'txt'): void {
    const blob =
        typeof fileTextOrBlob === 'string' ? new Blob([fileTextOrBlob], { type: 'text/plain' }) : fileTextOrBlob;
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');

    link.download = `${fileName}.${extension}`;
    link.href = url;
    link.id = DOWNLOADED_FILE_ID;

    document.body.appendChild(link);

    link.click();

    document.querySelector(`#${link.id}`)?.remove();
}
